import { schemaTypes } from '../../../constants/constants'
import ReportAPIs from '../../../APIs/ReportAPIs';
import { JSONToCSVConvertor } from '../../../helpers/helperFunctions'
import _ from 'lodash';
import moment from 'moment';
import { changeVehicle } from './historyReport/historyReport';
import { bmsStateMap, faultMap } from './canDataReport';

export const dateFormat = "DD-MMM-YYYY HH:mm";
window.dumpTime = {starttime: null, endtime: null}
let meta = [{ "battery_voltage": 'V' },
{ "current": 'A' },
{ "soc": '%' },
{ "controller_temperature": '°C' },
{ "motor_temperature": '°C' },
{ "speed": 'Kmph' },
{ "battery_current": 'A' },
{ "odometer": 'km' },
{ "soh": '%' },
{ "battery_temperature": '°C' },
{ "engine_speed": 'rpm' },
{ "vehicle_speed": 'kmph' }
]
const packCurrentStateMap = {
    1: "Charging",
    2: "Discharging",
    3: "Normal",
    4: "Ideal",
    5: "Current Sleep",
    6: "Regen",
  };
  
  const bms_power_mode = {
    0: "active_mode",
    1: "sleep_mode",
    2: "deepsleep_mode",
    3: "sleep_time_wakeup_mode",
  };

  const chargerstate={
    0: "Ideal",
    1: "Charging Battery",
    2: "stand-by",
    3: "battery failure",
    4: "charger failure"
  }

  const cc_cv_state_of_charger={
    0 : "cc_state",
    1 : "cv_state"
  }
  const charger_state_set={
    0: "turn off charger",
    1: "turn on charger",
    2: " full charge"
  }
const isToolDisabled = () => {
    // console.log(schema)
    return !schema.busy
}
const getCANDumpData = (schema, data, store) => {
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    let bmsState = false
    window.graphDataErr = ''
    if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
    }
    let starttime = data.starttime.unix() * 1000;
    let endtime = data.endtime.unix() * 1000;
    if(starttime > endtime){
        store.dispatch({
          type: "ADD_INTOAST",
          data: {
            name: "Start time should be less than the end time",
            content: "Start time should be less than the end time",
            createAt: Date.now(),
            autoClose: 8000,
            showError:true
          },
        });
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);
        return;
      }

    if (endtime - starttime > 8 * 86400 * 1000) {
        window.setReportWindowTabBusy(schema, false);
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
                name: "You can't select a date range of more than 7 days",
                content: "You can't select date range of more than 7 days",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
            },
        });
        return;
    }

    const auth = window.getAuth();
    let vehicleno = []
    data.vehicle.map(index => {
        vehicleno.push(index.data.vehicleno)
    })
    if (!vehicleno.length){
        window.graphDataErr = 'Please select a vehicle'
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);

        return;
    }
    let metrics = data.metrics.map((metrics) =>{
        return metrics.name
    })
    if(!metrics.length){
        window.graphDataErr = 'Please Select CAN Data Metrics'
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);
        return;
    }
    let body = {
        token: auth.token,
        vehicleno: vehicleno[0],
        starttime: data.starttime.unix() * 1000,
        endtime: data.endtime.unix() * 1000,
        metrics: metrics
    }
    for(let idx in metrics) {
        if(metrics[idx] === "status" && window.selectedVehicles[0] && window.selectedVehicles[0].data.vehicleModel &&
            window.selectedVehicles[0].data.vehicleModel.variant === "Lithion 500") bmsState = true
    }
    if(window.showNoGpsFixData === true){
        body.fixqfilter = false
    }
    const handleFailure = (err) => {
        window.setReportWindowTabBusy(schema, false);
        window.graphDataErr = err.response.data.msg || 'No data to download'
        if (err.response){
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
                name: "Failed",
                content: "Failed to download",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
            },
        });
        }
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        }
    const getBMSvalue = (value) => {
        let stateValue = ""
        for(let idx in bmsStateMap){
            if(bmsStateMap[idx].key === value){
                stateValue = bmsStateMap[idx].value
                break
            }
        }
        return stateValue
    }
    const getFaultValue = (value) => {
        let faultValue = ""
        for (let idx in faultMap) {
            if (faultMap[idx].key === value) {
                faultValue = faultMap[idx].value;
                break;
            }
        }
        return faultValue;
    }
    const handleSuccess = (resp) => {
        let fault_map = window.userInfo && window.userInfo.SELF && window.userInfo.SELF.fault_map ? true : false;
        
        window.graphDataErr = ''
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        let header = [];
        window.CANDUMP = []
        for (let i in resp) {

           // ✅ pack_current_state mapping
           if (fault_map) {
            // ✅ pack_current_state mapping
            if (resp[i].pack_current_state !== null && resp[i].pack_current_state !== undefined) {
              resp[i].pack_current_state =
                packCurrentStateMap[Number(resp[i].pack_current_state)] ??
                resp[i].pack_current_state;
            }
          
            // ✅ bms_power_mode mapping
            if (resp[i].bms_power_mode !== null && resp[i].bms_power_mode !== undefined) {
              resp[i].bms_power_mode =
                bms_power_mode[Number(resp[i].bms_power_mode)] ??
                resp[i].bms_power_mode;
            }

            // charger_state mapping
            if (resp[i].charger_state != null) {
                resp[i].charger_state =
                chargerstate[Number(resp[i].charger_state)] ??
                resp[i].charger_state;
            }

                // cc_cv_state_of_charger mapping
                if (resp[i].cc_cv_state_of_charger != null) {
                    resp[i].cc_cv_state_of_charger =
                    cc_cv_state_of_charger[Number(resp[i].cc_cv_state_of_charger)] ??
                    resp[i].cc_cv_state_of_charger;
                }

                 // charger_state_set mapping
                 if (resp[i].charger_state_set != null) {
                    resp[i].charger_state_set =
                    charger_state_set[Number(resp[i].charger_state_set)] ??
                    resp[i].charger_state_set;
                }

          }

            if(bmsState && resp[i].status !== null){
                let value = resp[i].status
                resp[i].status = getBMSvalue(value)
            }
            if (fault_map && resp[i].fault !== null && resp[i].fault !== undefined) {
                let fval = resp[i].fault;
                resp[i].fault = getFaultValue(fval);
            }
            for (let j in resp[i]) {
                if (!header.includes(j)) {
                    header.push(j)
                }
            }
        }
        for (let i in resp) {
            if (Object.keys(resp[i]).length) {
                let obj = {}
                header.map((key, index) => {
                    if(key == 'time'){
                        obj[key] = resp[i][key] != null? moment(resp[i][key]).format('DD-MM-YYYY  HH:mm:ss '):''   
                    }else{
                        let unit = ''
                        meta.map((data, index) => {
                            if (Object.keys(data)[0] == key) {
                                unit = Object.values(data)[0]
                            }
                        })
                        if(unit){
                            obj[key + '( ' + unit + ' )'] = resp[i][key] != null ? resp[i][key]:''
                        }else{
                            obj[key] = resp[i][key] != null ? resp[i][key]: ''

                        }
                    }
                })
                window.CANDUMP.push(obj)
            } 
        }
        if (window.CANDUMP.length){
            JSONToCSVConvertor(window.CANDUMP, "CAN Data Dump For_" + vehicleno[0] + '_' + moment(Date.now()).format('DD-MMM HH:mm:ss '), false,true, true)
        }else{
            window.graphDataErr = 'No data to download'
            if (window.InMapForceUpdate) {
                window.InMapForceUpdate();
            }
        }
        window.setReportWindowTabBusy(schema, false);
    }

    ReportAPIs.getCanDataDump(body).then((resp) => {
        handleSuccess(resp);
    },err=> handleFailure(err))

    if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
    }
}

const schema = {
    key: "can_data_dump_report",
    name: "CAN Data Dump",
    toolbar: [
        {
            key: "vehicle",
            type: schemaTypes.MULTI_SELECT,
            singleSelect: true,
            storeData: (state) => {
                return {
                    data: (() => {
                        let newMap = {};
                        for (let idx in state.vehicleMap) {
                            if (idx.indexOf("user") === -1) {
                                newMap[idx] = state.vehicleMap[idx];
                            }
                        }
                        return newMap;
                    })(),
                    name: "vehicleno",
                    id: "vehicleid",
                };
            },
            onItemChange: changeVehicle.bind(this),
            defaultValue: () => {
                return {
                    data: window.selectedVehicles.map((i) => {
                        return i.id;
                    }),
                    updatedAt: window.selectedVehiclesUpdatedAt,
                };
            },
        },
        
        {
            key: "starttime",
            type: schemaTypes.DATE_PICKER,
            setIfNull: true,
            placeholder: "Start Date",
            model: moment().subtract(1, "days").startOf("day"),
        },
        {
            key: "endtime",
            type: schemaTypes.DATE_PICKER,
            setIfNull: true,
            placeholder: "End Date",
            // model: Date.now()
            model: moment(Date.now()).add(0, "day").startOf("day"),
        },
        {
            key: "metrics",
            type: schemaTypes.MULTI_SELECT,
            storeData: (state) => {
                return {
                    data:window.metrics ,
                    name:"metrics",
                    id: "id"
                }            
            }
        },
        {
            key: "get_history",
            isDisabled: isToolDisabled,
            type: schemaTypes.BUTTON,
            name: "Download CAN Dump",
            onClick: getCANDumpData
        },

    ],
}
export default schema;